import { useFoodByUnit } from "../../queries/caches";
import { formatFoodDescription } from "../../utils/foodUtils";

/**
 * Suspender Lookup des Lebensmittel-Namens über eine FoodUnit-Id. MUSS in einer
 * `QueryBoundary` mit Skelett-Fallback verwendet werden – so wird während des
 * Ladens nie der Platzhalter "Zutat" gerendert.
 */
export function FoodName(props: { unitId: number | undefined }) {
  const food = useFoodByUnit(props.unitId);
  if (!food) return null;
  return <>{formatFoodDescription(food)}</>;
}

/** Wie `FoodName`, hängt aber Menge + Einheit an (z. B. Schritt-Vorschau). */
export function FoodUnitLabel(props: {
  unitId: number | undefined;
  amount: number;
}) {
  const food = useFoodByUnit(props.unitId);
  if (!food) return null;
  const foodUnit = food.foodUnits.find((unit) => unit.id === props.unitId);
  return (
    <>{`${formatFoodDescription(food)} ${props.amount}${foodUnit?.description ?? ""}`}</>
  );
}
